<template>
<div
	class="update-app" v-if="updateExists__">
	<div class="update-app__image">
		<img
			src="./../../assets/logo-small.png"
			class="d-inline-block align-top main-nav-logo"
			alt="MyMeet"
		>
	</div>
	<div class="update-app__title">{{ $t("A new version of MyMeet is available!") }}</div>
	<div class="update-app__description">{{ $t("You should update now.") }}</div>
	<div class="update-app__actions">
		<button class="btn btn-secondary btn-sm btn-raised btn-block update-app__button" type="button" @click="refreshApp__()">{{ $t("Update now") }}</button>
	</div>
</div>
</template>

<script>
import updateServiceWorker from '@/mixins/update-service-worker';

export default {
	mixins: [updateServiceWorker],
	components: {},
	data() {
		return {};
	},
	sockets: {
	},
	mounted() {},
	created() {},
	destroyed() {},
	beforeDestroy() {
	},
	computed: {},
	methods: {},
};
</script>

<style lang="scss" scoped>
</style>
